<template>
  <div>
    <div class="swipe-panel" v-if="isShow">
      <van-swipe :autoplay="3000" indicator-color="white">
        <van-swipe-item v-for="(item,index) in carouselImgs" :key="index">
          <div @click="gotoDetail(item)" class="swipe-one-panel">
            <van-image
              width="100%"
              height="100%"
              fit="cover"
              lazy-load
              :src="item.carouselImgUrl"
            />
          </div>
        </van-swipe-item>
      </van-swipe>
    </div>
  </div>
</template>

<script>
import * as Service from '@/services/HomeService'
export default {
  name: 'IndexSwipe',
  props: {
    isShow: Boolean
  },
  data() {
    return {
      carouselImgs:[]
    }
  },
  created(){
    this.getImgs()
  },
  methods: {
    getImgs(){
      Service.getCarouselImg().then((res)=>{
        for(let one of res){
          one.carouselImgUrl = this.$constants.IMAGE_BASEURL + one.carouselImgUrl
        }
        this.carouselImgs = res
      })
    },
    gotoDetail(item){
      if(item.commodityId === null || item.commodityId === ''){
        return
      }
      this.$router.push({
        path: '/detail',
        query: {
          commodityId: item.commodityId
        }
      })
    }
  }
}
</script>

<style scoped>
.swipe-panel{
  width: 100%;
}
.swipe-one-panel{
  height: 300px;
}
</style>